import React from 'react';
import { PhoneIcon, MessageCircleIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-purple-deep py-12 text-white" data-id="element-36" data-mp="3gfitoga0y7d2">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-37" data-mp="32nukakr5twzs">
        <div className="inline-flex items-center rounded-2xl bg-white px-4 py-2.5" data-id="element-38" data-mp="32p5kybpb6omo">
          <img src="https://cdn.magicpatterns.com/uploads/iyk1wLpUM4cZDTujufWbwN/Swift_Errands_Logo.png" alt="Swift Errands" className="h-9 w-auto" data-id="element-39" data-mp="36qhh702ou83u" />
        </div>

        <ul className="mt-6 flex flex-col gap-3 text-sm sm:flex-row sm:flex-wrap sm:gap-8" data-id="element-40" data-mp="38qz78i6g9vx">
          <li data-id="element-41" data-mp="3lecb2jsfmiii">
            <a href="tel:09030977339" className="flex items-center gap-2 text-white/85 transition hover:text-gold" data-id="element-42" data-mp="3lelybzm3ebki">
              <PhoneIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-43" data-mp="3qcnjqr6zqmz5" />
              09030977339
            </a>
          </li>
          <li data-id="element-44" data-mp="29xm24swmjcl7">
            <a href="https://wa.me/2349030977339" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-white/85 transition hover:text-gold" data-id="element-45" data-mp="2a19uhoqc1syc">
              <MessageCircleIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-46" data-mp="3laljxq66apz8" />
              WhatsApp 09030977339
            </a>
          </li>
          <li data-id="element-47" data-mp="3gctnciul2fop">
            <a href="mailto:swifterrands192@gmail.com" className="flex items-center gap-2 text-white/85 transition hover:text-gold" data-id="element-48" data-mp="3v7ggi3ivygav">
              <MailIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-49" data-mp="3q7u1bojhypzf" />
              swifterrands192@gmail.com
            </a>
          </li>
        </ul>

        <p className="mt-8 border-t border-white/15 pt-6 text-xs text-white/55" data-id="element-50" data-mp="33xge4qruavo">
          © {new Date().getFullYear()} Swift Errands. Market runs across Lagos.
        </p>
      </div>
    </footer>;
}